import { Injectable } from "@angular/core";
import { ApiService } from "./api-service";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SkillsWithoutCertificateService {
  constructor(private api: ApiService) {}

  // Add skills
  addSkills(body) {
    const url = `/SkillWithoutCertificate`;
    return this.api.post(url, body);
  }

  // get skills
  getSkills(id) {
    const url = `/SkillWithoutCertificate/applicant/${id}`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  deleteSkills(id){
    const url = `/SkillWithoutCertificate/${id}`;
    return this.api.delete(url);

  }

}